import { useDispatch, useSelector } from 'react-redux';
import {
  errorCodeSelector,
  refreshTokenSelector,
  tokenSelector,
} from './store/selector';
import { useCallback } from 'react';
import { PostLoginRequest } from './interfaces/post-login';
import { authApiService } from './services/api';
import {
  authClearAction,
  postLoginFailureApiAction,
  postLoginInitApiAction,
  postLoginSuccessApiAction,
} from './store/reducer';
import { companyClearAction } from '../company/store/reducer';
import { globalClearAction } from '../global/store/reducer';
import { meClearAction } from '../me/store/reducer';
import { userClearAction } from '../user/store/reducer';
import { metricsClearAction } from '../metrics/store/reducer';
import { reportsClearAction } from '../reports/store/reducer';

export function useAuthCore() {
  const token = useSelector(tokenSelector);
  const refreshToken = useSelector(refreshTokenSelector);
  const errorCode = useSelector(errorCodeSelector);
  const dispatch = useDispatch();

  const login = useCallback(
    async (body: PostLoginRequest, onSuccess?: () => void) => {
      try {
        dispatch(postLoginInitApiAction());
        const response = await authApiService.postLogin(body);
        dispatch(postLoginSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        dispatch(
          postLoginFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const clearAuth = useCallback(() => {
    dispatch(authClearAction());
  }, [dispatch]);

  const logout = useCallback(() => {
    dispatch(authClearAction());
    dispatch(companyClearAction());
    dispatch(globalClearAction());
    dispatch(meClearAction());
    dispatch(userClearAction());
    dispatch(metricsClearAction());
    dispatch(reportsClearAction());
  }, [dispatch]);

  return {
    token,
    refreshToken,
    errorCode,
    login,
    logout,
    clearAuth,
  };
}
